import httpClient from './httpClient';

export const sendContactForm = async (data) => {
    try {
        const response = await httpClient.post('/api/v1/contact-form', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};
